import React, { forwardRef, useState, useEffect } from 'react';
import OrganisationType from '../OrganisationType';
import styles from './ExistingLicence.module.scss';
import { Notification } from '@snsw/react-component-library';
import GenericOrganisationSearch from '../GenericOrganisationSearch';

const ExistingLicence = ({ detailStyle, ...props }, ref) => {
  const apiURL = `${typeof props.baseUrl !== 'undefined' ? props.baseUrl : 'http://localhost:4001'}`;
  const apiRoute = `${props.apiRoute || '/orgSearchApi'}`;
  const apiAbnRoute = `${props.apiAbnRoute || '/abnAcnApi/Lookup/GetAbrDetailsByAbn'}`;
  const apiAcnRoute = `${props.apiAcnRoute || '/abnAcnApi/Lookup/GetAbrDetailsByAcn'}`;

  const registrationRef = React.createRef();
  const [typeError, setTypeError] = useState(false);

  useEffect(() => {
    setTypeError(false);
  }, [props.regoType]);

  if (ref) {
    ref.current = {
      validate: () => {
        // if (!props.regoType) {
        //   setTypeError(true);
        //   return false;
        // } else if (props.regoType === 'YINC' && YINCRef.current) {
        //   setTypeError(false);
        //   return YINCRef.current.validate();
        // } else if ((props.regoType === 'ABN' || props.regoType === 'ACN') && ABNACNRef.current) {
        //   setTypeError(false);
        //   return ABNACNRef.current.validate();
        // } else if ((props.regoType === 'Other' || props.regoType === 'Other') && registrationRef.current) {
        //   setTypeError(false);
        //   return registrationRef.current.validate();
        // }
      }
    };
  }

  let title = props.regoType;
  switch (props.regoType) {
    case 'ABN':
      title = `${props.labels?.abn ?? 'ABN'} Number`;
      break;
    case 'ACN':
      title = `${props.labels?.acn ?? 'ACN'} Number`;
      break;
    case 'YINC':
      title = `${props.labels?.yinc ?? 'Assoc. Incorporated'} Number`;
      break;
    case 'Other':
      title = `${props.labels?.other ?? 'Other'} Number`;
      break;
  }
  console.info(`${apiURL}${apiRoute}`);

  return (
    <>
      <OrganisationType
        regoType={props.regoType}
        setRegoType={(rt) => {
          if (props.setRegoType) {
            props.setRegoType(rt);
            registrationRef?.current?.clear();
          }
        }}
        disableABN={false}
        disableACN={false}
        disableYINC={false}
        disableOther={false}
        labels={props.labels}
        useSelect={props.useSelect}
      />
      {typeError ? (
        <div className={'row'}>
          <div className={`col-12 ${styles.errorMessage}`}>
            <Notification variant="error" title={'Registration Type is required.'} />
          </div>
        </div>
      ) : null}

      {props.regoType ? (
        <GenericOrganisationSearch
          {...props}
          title={detailStyle === 1 ? title : 'Registration number'}
          url={`${apiURL}${apiRoute}`}
          abnUrl={`${apiURL}${apiAbnRoute}`}
          acnUrl={`${apiURL}${apiAcnRoute}`}
          ref={registrationRef}
          detailStyle={detailStyle}
        />
      ) : null}
    </>
  );
};
export default forwardRef(ExistingLicence);
